module.exports = __webpack_public_path__ + "img/ELSYS_ELT2-HP.bde15a35.png";